<template>
  <section
    class="card form-card"
    :class="[source ? `source-${source}` : null, { 'form-card-filled': filled }]"
  >
    <header v-if="title || subtitle || $slots.header || $slots.title" class="form-card-header">
      <h2 v-if="title || $slots.title" class="form-card-title">
        <i v-if="source" class="source-dot"></i>{{ title }}<slot name="title" />
      </h2>
      <p v-if="subtitle" class="form-card-subtitle">{{ subtitle }}</p>
    </header>
    <slot />
  </section>
</template>

<script>
export default {
  name: 'FormCard',
  props: {
    title: { type: String, default: '' },
    subtitle: { type: String, default: '' },
    source: { type: String, default: '' },
    filled: { type: Boolean, default: false },
  },
}
</script>

<style scoped>
.card.form-card {
  background: #fff;
  border: 1px solid #e5e7eb;
  border-radius: 14px;
  box-shadow: 0 8px 24px rgba(15, 23, 42, 0.06);
  margin-bottom: 18px;
  padding: 20px;
}

.form-card-filled {
  border-color: #28a745;
}

.form-card-header {
  margin-bottom: 14px;
}

.form-card-title {
  align-items: center;
  color: #111827;
  display: flex;
  font-size: 18px;
  font-weight: 700;
  gap: 8px;
  margin: 0 0 6px;
}

.form-card-subtitle {
  color: #6b7280;
  font-size: 13px;
  font-weight: 400;
  margin: 0;
}

.source-general { --source-color: #22c55e; }
.source-customer { --source-color: #3b82f6; }
.source-carrier { --source-color: #8b5cf6; }
.source-subsidy { --source-color: #f59e0b; }
.source-info { --source-color: #2563eb; }
.source-warning { --source-color: #f59e0b; }

.source-dot {
  background: var(--source-color, #6b7280);
  border-radius: 50%;
  display: inline-block;
  flex: 0 0 auto;
  height: 9px;
  width: 9px;
}
</style>
